import { Component, inject, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterLink, RouterOutlet  } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Link } from '../../model/link';
import { AdminNavigationService } from '../../admin-navigation/admin-navigation.service';

@Component({
    selector: 'update-subscription',
    imports: [
        MatTabsModule,
        RouterLink,
        RouterOutlet,
        TranslateModule
    ],
    templateUrl: './update-subscription.component.html',
    styleUrl: './update-subscription.component.css'
})
export class UpdateSubscriptionComponent implements OnInit{

  private adminService = inject(AdminNavigationService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  links: Link[] = [
    { id: 0, text: 'update-subscription.by_user_id', path: 'user-id' },
    { id: 1, text: 'update-subscription.by_email', path: 'email' },
    { id: 2, text: 'update-subscription.by_payment_id', path: 'payment-id' },
    { id: 3, text: 'update-subscription.by_subscription_id', path: 'subscription-id' }
  ];
  activeLink: Link = this.links[0];

  ngOnInit(): void {

    this.adminService.titleId.set('update-subscription.title');

    //this.router.navigate([this.activeLink.path], { relativeTo: this.route });
  }
}
